import { createFlagOverridesFromMap, OverrideBehaviour, type FlagOverrides } from "configcat-react";

export const Flags = {
    OnaAIEnabled: "onaAIEnabled",
    OnaEnvironmentOnboardingEnabled: "isOnaEnvironmentOnboardingEnabled",
    InsightsDisabled: "isInsightsDisabled",

    IsGcpRunnerEnabled: "is_gcp_runner_enabled",
    GlobalOverload: "global_overload",
    EnableAgentFollowMode: "enable_agent_follow_mode",
    IsSentryEnabled: "is_frontend_dash_sentry_enabled",
    WorkflowsEnabled: "workflows_enabled",
    IsMobileVscodeEnabled: "is_mobile_vscode_enabled",
    UseReleasesProxy: "use_releases_proxy",
    SpecModeEnabled: "spec_mode_enabled",
    RalphModeEnabled: "ralph_mode_enabled",
    EnableFailedPaymentReconciler: "enableFailedPaymentReconciler",

    OnaIntelligenceConsumptionUIEnabled: "ona_intelligence_consumption_ui_enabled",
    AutomationsRepoListModeEnabled: "automations_repo_list_mode_enabled",

    ReviewCommentsEnabled: "review_comments_enabled",
    ReusableWebhooksEnabled: "reusable_webhooks_enabled",
    OrgRolesEnabled: "org_roles_enabled",
    ShareableOnaLinksEnabled: "shareable_ona_links_enabled",
    SCIMEnabled: "scim_enabled",
    AgentImageAttachmentsEnabled: "agent_image_attachments_enabled",
    DevRunnerRegistrationEnabled: "dev_runner_registration_enabled",
    CommandsAreSkills: "commands_are_skills",
    SSOAdditionalScopesEnabled: "sso_additional_scopes_enabled",
    VetoExecutions: "veto_executions",
    DashboardUpdatedNudgeEnabled: "dashboardUpdatedNudgeEnabled",
    MCPIntegrationsUIEnabled: "mcp_integrations_ui",
    AutoTopupEnabled: "auto_topup_enabled",
    CreditUsageEnabled: "creditUsageEnable",
    RunnerSideAgentEnabled: "runner_side_agent_enabled",
};

export function getLocalStorageKey(flag: string): string {
    return `feature_flag_${flag}`;
}

export function localFlagOverrides(): FlagOverrides {
    const overrides: Record<string, boolean | number> = {};

    for (const flagKey of Object.values(Flags)) {
        const storageKey = getLocalStorageKey(flagKey);
        const storedValue = localStorage.getItem(storageKey);
        if (storedValue !== null) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedValue = JSON.parse(storedValue);
                if (typeof parsedValue === "boolean" || typeof parsedValue === "number") {
                    console.debug(`Local flag override from localStorage: ${flagKey} = ${parsedValue}`);
                    overrides[flagKey] = parsedValue;
                }
            } catch (e) {
                console.warn(`Failed to parse localStorage value for flag ${flagKey}`, e);
            }
        }
    }

    return createFlagOverridesFromMap(overrides, OverrideBehaviour.LocalOverRemote);
}
